import React from 'react';
import { tr } from '../../i18n';
import LegalDocumentLinks from './LegalDocumentLinks';
import { operator } from './operator';

/** Общий футер сайта: контакт и постоянные кнопки юридических документов. */
const SiteFooter: React.FC = () => (
  <footer className="cabinet-footer">
    <div className="cabinet-footer-inner">
      <LegalDocumentLinks variant="footer" ariaLabel={tr.shell.legal.documents} />
      <div className="cabinet-footer-row">
        <span>© {new Date().getFullYear()} Ratten Run</span>
        <a href={`mailto:${operator.email}`} className="cabinet-footer-link">{operator.email}</a>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
